export default __webpack_public_path__ + "static/media/explorer.f8db2d44.png";